import {
  isMobileOnly,
  isTablet,
  isDesktop,
  osVersion,
  osName,
  browserName
} from 'react-device-detect';

export default class DeviceService {
  public static Android(){
    return navigator.userAgent.match(/Android/i)
  };
  public static BlackBerry(){
    return navigator.userAgent.match(/BlackBerry/i);
  }
  public static iOS(){
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  }
  public static Opera(){
    return navigator.userAgent.match(/Opera Mini/i);
  }
  public static Windows(){
    return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
  }
  public static isAny() {
    return (this.Android() || this.BlackBerry() || this.iOS() || this.Opera() || this.Windows())
  }

  public static fullInfo(){
    return {
      type: isMobileOnly ? 'mobile' : isTablet ? 'tablet' : isDesktop ? 'desktop' : 'unknown',
      browser: browserName,
      operatingSystem: osVersion,
      platform: osName,
    }
  }
};
